/**
 * @file Submission read-only / review UI components — buildDatasetOverviewSections.tsx.
 */

import React from "react";
import ContributorDetailsReadonlySection from "../ContributorDetailsReadonlySection";
import PublicationDetailsReadonlySection from "../PublicationDetailsReadonlySection";
import BackgroundDetailsReadonlySection from "../BackgroundDetailsReadonlySection";
import A1DetailsReadonlySection from "../A1DetailsReadonlySection";
import A2DetailsReadonlySection from "../A2DetailsReadonlySection";
import A3DetailsReadonlySection from "../A3DetailsReadonlySection";
import A1A3DetailsReadonlySection from "../A1A3DetailsReadonlySection";
import DatasetOverviewConditionalContent from "./DatasetOverviewConditionalContent";
import DatasetOverviewStagePlaceholder from "./DatasetOverviewStagePlaceholder";
import type { DatasetOverviewSectionDefinition } from "./types";

/** Exported function — build Dataset Overview Sections. */
export function buildDatasetOverviewSections(): DatasetOverviewSectionDefinition[] {
  return [
    {
      key: "contributor-details",
      title: "Contributor Details",
      renderBody: ({ submission }) => (
        <ContributorDetailsReadonlySection submission={submission} />
      ),
    },
    {
      key: "publication-details",
      title: "Publication Details",
      renderBody: ({ submission }) => (
        <PublicationDetailsReadonlySection submission={submission} />
      ),
    },
    {
      key: "background-data",
      title: "Background Data",
      renderBody: ({ submission }) => (
        <BackgroundDetailsReadonlySection submission={submission} />
      ),
    },
    {
      key: "a1",
      title: "A1 — Raw Material Extraction",
      renderBody: ({ submission, showA1 }) => (
        <DatasetOverviewConditionalContent
          show={showA1}
          placeholder={<DatasetOverviewStagePlaceholder stageLabel="A1" />}
        >
          <A1DetailsReadonlySection submission={submission} />
        </DatasetOverviewConditionalContent>
      ),
    },
    {
      key: "a2",
      title: "A2 — Raw Material Transport",
      renderBody: ({ submission, showA2 }) => (
        <DatasetOverviewConditionalContent
          show={showA2}
          placeholder={<DatasetOverviewStagePlaceholder stageLabel="A2" />}
        >
          <A2DetailsReadonlySection submission={submission} />
        </DatasetOverviewConditionalContent>
      ),
    },
    {
      key: "a3",
      title: "A3 — Manufacturing",
      renderBody: ({ submission, showA3 }) => (
        <DatasetOverviewConditionalContent
          show={showA3}
          placeholder={<DatasetOverviewStagePlaceholder stageLabel="A3" />}
        >
          <A3DetailsReadonlySection submission={submission} />
        </DatasetOverviewConditionalContent>
      ),
    },
    {
      key: "a1a3",
      title: "A1-A3 Summary",
      renderBody: ({ submission, showA1A3 }) => (
        <DatasetOverviewConditionalContent
          show={showA1A3}
          placeholder={<DatasetOverviewStagePlaceholder stageLabel="A1-A3" />}
        >
          <A1A3DetailsReadonlySection submission={submission} />
        </DatasetOverviewConditionalContent>
      ),
    },
  ];
}
